/*
 * @Author: Admni
 * @Description: 
 * @Date: 2021-03-15 10:09:04
 * @LastEditTime: 2021-03-16 16:10:40
 */
import request from '@/utils/request.js'

export function getSpeedChart(data) {
    return request({
        url: '/api/dashboard/ss/delayQ/',
        method: 'post',
        data
    })
}

export function getOthersChart(data) {
    return request({
        url: '/api/dashboard/ss/delayI/',
        method: 'post',
        data
    })
}

export function getChartOptions(params) {
    return request({
        url: `/api/dashboard/ss/delayF`,
        method: 'get',
        params
    })
}

export function getTimeSpeedChart(data) {
    return request({
        url: '/api/dashboard/ss/usedQ/',
        method: 'post',
        data
    })
}

export function getTimeOthersChart(data) {
    return request({
        url: '/api/dashboard/ss/usedI/',
        method: 'post',
        data
    })
}

export function getTimeChartOptions(params) {
    return request({
        url: `/api/dashboard/ss/usedF`,
        method: 'get',
        params
    })
}